// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/interview-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   INTERVIEW CARD - G42 BRANDING
   ========================================== */

.interview-card {
  background: var(--interview-bg-white);
  border-radius: var(--interview-radius-3xl);
  padding: 40px 42px;
  box-shadow: var(--interview-shadow-card);
  max-width: var(--interview-container-md);
  width: 100%;
  margin: 0 auto;
}

.interview-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 22px;
}

.interview-card-logo {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.interview-card-logo svg {
  width: 30px;
  height: 30px;
}

.interview-card-title {
  font-size: var(--interview-text-md);
  font-weight: 800;
  color: var(--interview-text-primary);
  margin: 0;
  letter-spacing: 0;
}

.interview-card-content {
  display: flex;
  flex-direction: column;
}

@media (max-width: 576px) {
  .interview-card {
    padding: var(--interview-space-3xl) var(--interview-space-2xl);
    border-radius: var(--interview-radius-2xl);
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Interview/InterviewCard/InterviewCard.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAI/C;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;EACxC,wCAAwC;EACxC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,oCAAoC;EACpC,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,8DAA8D;IAC9D,0CAA0C;IAC1C,eAAe;EACjB;AACF","sourcesContent":["/* ==========================================\n   INTERVIEW CARD - G42 BRANDING\n   ========================================== */\n\n@import '../../../styles/interview-theme.css';\n\n.interview-card {\n  background: var(--interview-bg-white);\n  border-radius: var(--interview-radius-3xl);\n  padding: 40px 42px;\n  box-shadow: var(--interview-shadow-card);\n  max-width: var(--interview-container-md);\n  width: 100%;\n  margin: 0 auto;\n}\n\n.interview-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 22px;\n}\n\n.interview-card-logo {\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.interview-card-logo svg {\n  width: 30px;\n  height: 30px;\n}\n\n.interview-card-title {\n  font-size: var(--interview-text-md);\n  font-weight: 800;\n  color: var(--interview-text-primary);\n  margin: 0;\n  letter-spacing: 0;\n}\n\n.interview-card-content {\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 576px) {\n  .interview-card {\n    padding: var(--interview-space-3xl) var(--interview-space-2xl);\n    border-radius: var(--interview-radius-2xl);\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
